import { IPresetAnimationControllerOption } from "@r3f/animationControllers/presetAnimationController";
import { IComponentType, IComponentsById, IModel3dAnimationOptions, ISceneComp, ITrackingTypes } from "@r3f-component-data-structure";
import { getFaceTrackedComponentIds } from "@r3f/hooks/useGetScreenRelativeComponentIds";
import { getModelAndPresetAnimationControllerOptions } from "@r3f/utils/actions";
import { isAbstractComponent } from "@r3f/utils/general";

interface IOutput {
    model: IModel3dAnimationOptions[];
    preset: IPresetAnimationControllerOption[];
}

interface ISceneIdToEntityIdsDict {
    [sceneId: string]: string[]
}
 
export const getAllAnimationControllerOptions = (componentsById: IComponentsById): IOutput => {
    let presetOptions: IPresetAnimationControllerOption[] = [];
    let modelOptions: IModel3dAnimationOptions[] = [];
    let sceneIdToEntityIdsDict = getSceneIdToEntityIdsDict(componentsById);
    for (const key in componentsById) {
        const component = componentsById[key];
        if (isAbstractComponent(component) && component.type !== IComponentType.Scene || !component.actions) continue;
        const options = getModelAndPresetAnimationControllerOptions(component.actions, key);
        const parentSceneId = Object.keys(sceneIdToEntityIdsDict).includes(key) ? key : getSceneIdForEntityId(sceneIdToEntityIdsDict, key)
        options.preset.forEach(option => option.parentSceneId = parentSceneId);
        presetOptions = [...presetOptions, ...options.preset];
        modelOptions =  [...modelOptions, ...options.model];
    }
    return {preset: presetOptions, model: modelOptions}
} 

const getSceneIdToEntityIdsDict = (componentsById: IComponentsById) => {
    const dict: ISceneIdToEntityIdsDict = {}
    for (const key in componentsById) {
        const component = componentsById[key];
        if (component.type !== IComponentType.Scene) continue;
        if (component.trackingType === ITrackingTypes.face) {
            dict[key] = getFaceTrackedComponentIds(key, componentsById)
            addScreenContentSpatialChildrenToDict(component, componentsById, key, dict)
            continue;
        }
       dict[key] = component.children.filter(id => !isAbstractComponent(componentsById[id]))
       addScreenContentSpatialChildrenToDict(component, componentsById, key, dict)
    }
    return dict;
}

const addScreenContentSpatialChildrenToDict = (scene: ISceneComp, componentsById: IComponentsById, sceneId: string, dict: ISceneIdToEntityIdsDict) => {
    const screenContentId = scene.children.filter(id => componentsById[id].type === IComponentType.ScreenContent)[0]
    if (screenContentId) recursivelyAddSpatialComponentChildrenIdsToDict(screenContentId, componentsById, sceneId, dict);
}

const recursivelyAddSpatialComponentChildrenIdsToDict = (componentId: string, componentsById: IComponentsById, sceneId: string, dict: ISceneIdToEntityIdsDict) => {
    const component = componentsById[componentId]
    if (isAbstractComponent(component)) {
        for (let i = 0; i < component.children.length; i++) {
            recursivelyAddSpatialComponentChildrenIdsToDict(component.children[i], componentsById, sceneId, dict);
        }
        return;
    }
    if (!dict[sceneId]) dict[sceneId] = []
    dict[sceneId].push(component.id);
}

const getSceneIdForEntityId = (dict: ISceneIdToEntityIdsDict, entityId: string) => {
    let parentSceneId: string;
    for (const key in dict) { 
        if (dict[key].includes(entityId)) {
            parentSceneId = key;
        }
    }
    return parentSceneId!;
}

